
export class ConnexionData {
    email: string;
    password: string;
  
    constructor() {
      this.email = null;
      this.password = null;
    }
  }